export default __webpack_public_path__ + "static/Virsat Adipec 2022 Registration Steps-fc28786abd1112ef1beb2b8655c60e4b.jpg";